import {alphas, greys, greysDark} from '../../styles/colorStyles';
import {redesignedDarkInputSemanticStyles, redesignedLightInputSemanticStyles} from './inputSemanticStyles';

export interface SearchBarSemanticStyles {
  inputBackground: string;
  text: string;
  textHover: string;
  buttonHoverBackground: string;
  placeholder: string;
  tokenBackground: string;
}

// Styles which are shared between the dark and light themes. Most of the search
// bar does not change appearance between the themes.
export const sharedSearchBarSemanticStyles = {
  inputBackground: alphas.white30,
  text: greys.white,
  textHover: greys.shade30,
  buttonHoverBackground: alphas.black40,
  placeholder: alphas.white40,
  tokenBackground: alphas.black50,
} as const satisfies SearchBarSemanticStyles;

export const redesignedLightSearchBarSemanticStyles: SearchBarSemanticStyles = {
  inputBackground: redesignedLightInputSemanticStyles.background,
  text: greys.shade80,
  textHover: greys.shade90,
  buttonHoverBackground: greys.shade30,
  placeholder: greys.shade70,
  tokenBackground: greys.shade30,
} as const satisfies SearchBarSemanticStyles;

export const redesignedDarkSearchBarSemanticStyles: SearchBarSemanticStyles = {
  inputBackground: redesignedDarkInputSemanticStyles.background,
  text: greysDark.shade80,
  textHover: greysDark.shade90,
  buttonHoverBackground: greysDark.shade30,
  placeholder: greysDark.shade70,
  tokenBackground: greysDark.shade50,
} as const satisfies SearchBarSemanticStyles;
